<template>
	<section class="recharge">
		<Nav title="充值" />
		<section class="full_box">
			<div class="full_num">
				<h4>请选择充值推广币</h4>
				<div class="list">
					<div class="item" @click="chooseNum(i)" :class="{active: activeIndex==i}" v-for="(item,i) in numList" :key="item.id">
						<span>{{item.salesPrice/100}}币</span>
					</div>
				</div>
			</div>
			<div class="zhifu">
				<p class="tit">请选择支付方式</p>
				<van-cell :title="item.cashierTypeName" :icon="item.icon" v-for="item in typeList" :key="item.id">
					<template #right-icon>
						<div v-if="cashierTypeId==item.id">
							<img src="../../../assets/img/check_a.png" class="check" @click="checkFn(item.id)">
						</div>
						<div v-else>
							<img src="../../../assets/img/check.png" class="check" @click="checkFn(item.id)">
						</div>
					</template>
				</van-cell>
				<van-collapse v-model="activeNames">
					<van-collapse-item title="购买注意事项" name="1">
						<p>1. 推广币仅限在本平台购进行委托推广，不做他用，不得转让、赠予，也无法提现。</p>
					</van-collapse-item>
				</van-collapse>
			</div>
			<div class="bottom_btn">
				<div class="left">
					<div>
						<div>
							<p>支付金额</p>
							<span>¥</span>
							<i>{{price}}</i>
						</div>
					</div>			
				</div>
				<div class="right">
					<van-button type="danger" class="danger-button" @click="payFn">立即购买</van-button>
				</div>
			</div>
		</section>
	</section>
</template>

<script>
import settingServer from "api/setting";

import Nav from "components/Nav"
import { Notify } from 'vant';



export default {
	components: {
		Nav,
	},
	data() {
		return {
			numInit: 100,
			numList: [],
			price: '',
			skuId: '',
			activeIndex:0,
			activeNames: [0],
			isCheck: 1,
			clientType: this.$store.state.clientType,  //客户端类型 1-iOS 2-安卓 3-h5	
			params: {
				orderId: '',
				amount: '',
			},
			cashierTypeId: '',
			typeList: [],
            cashierTypeCode: '',
			//优惠券
			isTicketNum: 0,
			tickeId: '',
			tickeTxt: '',
			tickeTitle: '',
			isSuitable: '',
			ticketCount: '',
			discounts: '',
			minAmount: '',
		}
	},
	created() {
		this.params.orderId = this.$route.params.id
		this.activeIndex = this.$route.query.index||0
		this.getNumList()
		this.getPayList()
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
	methods: {
		getPayList () {
			settingServer.getCashierTypeList().then((res) => {
				this.typeList = res.data;
				this.cashierTypeId = this.typeList[0].id
                this.cashierTypeCode = this.typeList[0].code
			})
		},

		getNumList() {
			settingServer.getRechargePackagePageList({ pageNum:1, pageSize:100 }).then((res) => {
				this.numList = res.data.list
				// Sort the numList array in ascending order of salesPrice
				this.numList.sort((a, b) => a.salesPrice - b.salesPrice)

				this.price = this.numList[this.activeIndex].salesPrice/this.numInit
				this.skuId = this.numList[this.activeIndex].id
				if(this.tickeId) {
					this.getTicketInfo()
				}else {

				}
			})
		},

		chooseNum(i) {
			this.activeIndex = i
			this.price = this.numList[i].salesPrice/100
			this.skuId = this.numList[i].id
		},

		checkFn(id) {
			this.cashierTypeId = id
            this.cashierTypeCode = this.typeList[id].code
		},

		payFn() {
            this.requestPay()
		},

		requestPay() {
			if(!this.isCheck) return Notify({ type: 'danger', message: '请选择支付方式' })

            settingServer.submitRechargeOrder({id: this.skuId, paymentChannel: 7}).then((res) => {
                localStorage.setItem("rechargeStatus", 0)
                this.$router.push({name: 'payview', params:{orderNo:res.data, cashierTypeId:this.cashierTypeId, cashierTypeCode:this.cashierTypeCode }})
            })
		},
	}
}
</script>

<style lang="scss">
	.recharge {
		padding-top: 46px;
		color: #2B2F3A;
		.full_num {
			padding: 19px 21px;
			padding-bottom: 0;
			padding-right: 0;
			background: #fff;
			margin-bottom: 16px;
			h4 {
				font-size: 15px;
				padding-bottom: 18px;
			}
			p {
				font-size: 16px;
				padding-top: 7px;
				padding-bottom: 20px;

			}
			.list {
				display: flex;
				flex-wrap: wrap;
				.item {
					position: relative;
					width: 102px;
					height: 71px;
					font-size: 16px;
					line-height: 71px;
					border-radius: 4px;
					background: #fff;
					text-align: center;
					margin-bottom: 16px;
					margin-right: 13px;
					border: 1px solid #7E92E2;
					color: #3A5EEC;
					span {
						position: relative;
						z-index: 2;
					}
					img {
						position: absolute;
						bottom: 0;
						right: 0;
						width: 83px;
						z-index: 1;
					}
				}
				.active {
					background: #3A5EEC;
					color: #fff;
					font-weight: bold;

				}
			}
		}
		.zhifu {
			background: #fff;
			.tit {
				color: #7D8290;
				font-size: 14px;
				padding: 13px 19px;
			}
			.van-cell {
				// height: 50px;
				align-items: center;
				padding: 10px 21px;
				display: flex;
				align-items: center;
			}
			.van-cell__title {
				font-size: 15px;
				color: #2B2F3A;
			}
			.van-icon__image, .check {
				width: 22px;
				height: 22px;
			}
			.van-cell__left-icon, .van-cell__right-icon {
				height: 22px;
				width: 22px;
			}
			.van-collapse {
				border-top: 1Px solid #F6F6F6;
				.van-cell__right-icon {
					color: #7D8290;
				}
				span {
					color: #7D8290;
					font-size: 14px;

				}
				.van-icon {
					color: #CCCED4;
					font-size: 18px;
				}
			}
			.van-collapse-item__title--expanded::after, .van-cell::after {
				display: none;
			}
			.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
				border: 0;
				// border-top: 1Px solid #f6f6f6;
			}
			.van-collapse-item__content {
				color: #7D8290;
				font-size: 14px;
				p {
					padding-bottom: 8px;
				}
			}
			
		}
		.ticket {
			border-top: 1Px solid #f6f6f6;
			margin-top: 6px;
			padding: 16px 19px;
			padding-bottom: 0;
			.tits {
				color: #7D8290;
				font-size: 14px;
			}
			.ticket_info {
				display: flex;
				justify-content: space-between;
				.left {
					display: flex;
					align-items: center;
					font-size: 15px;
					color: #2B2F3A;
					img {
						width: 22px;
						margin-right: 7px;
					}
					i {
						font-style: normal;
						padding-left: 6px;
						color: #A2A6AE;
						font-size: 12px;
					}
				}
				.right {
					display: flex;
					align-items: center;
					padding: 19px 0;
					i {
						font-style: normal;
						color: #3A5EEC;
						font-size: 14px;
					}
					span {
						color: #7D8290;
						font-size: 14px;
						padding-right: 2px;
					}
					.van-icon {
						font-size: 16px;
						color: #CCCED4;
					}
					.ticket_name {
						padding-right: 2px;
						.name {
							color: #575F72;
							font-size: 13px;
						}
						.suitable {
							color: #A2A6AE;
							font-size: 12px;
						}
						.inconformity {
							color: #FC0E2D;
							font-size: 12px;
						}
					}

				}
			}
		}
		.bottom_btn {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			display: flex;
			align-items: center;
			height: 56px;
			.left {
				width: 52%;
				padding-left: 21px;
				background: #FFF;
				height: 56px;
				display: flex;
				align-items: center;
				div div {
					display: flex;
					align-items: center;
					p {
						font-size: 16px;
					}
					span {
						font-size: 15px;
						font-weight: bold; 
						padding-left: 6px;
						
					}
				}
				.youhui {
					color: #3A5EEC;
					font-size: 12px;
				}
				
				i {
					font-size: 20px;
					font-weight: bold;
					font-style: normal;
				}
			}
			.right {
				width: 48%;
				.danger-button {
					width: 100%;
					height: 56px;
					font-size: 17px;
					font-weight: bold;
					border: 0;
				}
			}


		}
		.recharge_success, .recharge_fail {
			position: fixed;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			text-align: center;
			width: 100%;
			img {
				width: 104px;
			}
			p {
				color: #2B2F3A;
				font-size: 20px;
				font-weight: bold;
				padding-top: 15px;
			}
			.van-button--danger {
				margin-top: 68px;
				width: 217px;
				height: 46px;
				font-size: 17px;
				font-weight: bold;
				.van-button__text {
					color: #fff;
					padding-top: 0;
				}
				
			}

		}
		.recharge_loading {
			position: fixed;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			text-align: center;
			width: 100%;
			img {
				width: 120px;
			}
			p {
				color: #575E72;
				font-size: 16px;
				padding-top: 36px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/setting/wallet/Recharge.vue